import { paginationFragment } from './fragments/pagination';
import { salesLeadFragment } from './fragments/salesLeads';

const fragment = `
  id
  beds
  baths
  garages
  sizeSqft
  finalPrice
  homeUrl
  createdAt
  singleFamilyHome {
    model {
      id
      name
      imageUrl
      defaultImageUrl
      productType {
        id
        name
      }
    }
    community {
      id
      name
      city {
        id
        name
      }
    }
    elevation {
      id
      imageUrl
    }
    isQuickPossession
    quickPossession {
      id
      address
      imageUrl
    }
    isLot
    lot
  }
  multiFamilyHome {
    project {
      id
      name
      address
      city {
        id
        name
      }
    }
    unit {
      id
      name
      defaultImageUrl
      address
      buildingModel {
        id
        name
        bedrooms
        bathrooms
        size
      }
    }
  }
  offer {
    id
    offerPrice
    counterOfferPrice
    status
    statusChangeDates
    isUsingRealtor
    realtorName
    requiredDepositAmount
    docuSignTemplateId
    signStatus
    signStatusChangeDates
    signNote
    signedDocumentUrl
    createdAt
    manuallyCompletedAt
    documentToSign {
      id
      name
      fileUrl
    }
    salesLead {
      ${salesLeadFragment}
    }
  }
  deposit {
    id
    amount
    status
    statusChangeDates
    errorMessage
    payoutStatus
    payoutErrorMessage
    note
    paymentVendor
    paymentMethod
    confirmed
    partialRefund @include(if: $withRefundStatus)
    fullRefund @include(if: $withRefundStatus)
    creditAllowed @include(if: $withCreditAllowed)
    authorizationStatus
    authorizationErrorMessage
  }
  totalOffers @include(if: $withTotalOffers)
  contact @include(if: $withContact) {
    id
    name
    email
    street
    state
    zip
    phone
    coBuyersCount(companyId: $companyId)
    user {
      preApproval @include(if: $withPreApproval) {
        id
        verificationMethod
        documentUrl
      }
    }
    companyContact(companyId: $companyId) {
      affordability @include(if: $withAffordability) {
        maxHomeAffordability
        assessedAt
        monthlyMortgagePayment
        maxRentingAmount
        annualIncome
      }
    }
    party(companyId: $companyId) @include(if: $withParty) {
      affordability @include(if: $withAffordability) {
        maxHomeAffordability
        assessedAt
        monthlyMortgagePayment
        maxRentingAmount
        annualIncome
      } 
    }
  }
`;

export const listHomesQuery = `
  query ListHomes(
    $filter: HomeFilterInput!
    $companyId: Int!
    $withTotalOffers: Boolean! = false
    $withContact: Boolean! = false
    $withPreApproval: Boolean! = false
    $withAffordability: Boolean! = false
    $withParty: Boolean! = false
    $withCreditAllowed: Boolean! = false
    $withRefundStatus: Boolean! = false
    $page: Int
    $pageSize: Int
  ) {
    result: listHomes(filter: $filter, page: $page, pageSize: $pageSize) {
      items {
        ${fragment}
      }
      pagination {
        ${paginationFragment}
      }
    }
  }
`;

export const getHomeQuery = `
  query GetHome(
    $id: Int!
    $companyId: Int!
    $withTotalOffers: Boolean! = false
    $withContact: Boolean! = false
    $withPreApproval: Boolean! = false
    $withAffordability: Boolean! = false
    $withParty: Boolean! = false
    $withCreditAllowed: Boolean! = false
    $withRefundStatus: Boolean! = false
  ) {
    item: getHome(id: $id, companyId: $companyId) {
      ${fragment}
    }
  }
`;

export const deleteHomeQuery = `
  mutation DeleteHome(
    $id: Int!
  ) {
    item: deleteHome(id: $id) {
      id
    }
  }
`;

export const markHomeAsSoldQuery = `
  mutation MarkHomeAsSold($id: Int!) {
    sold: markHomeAsSold(id: $id)
  }
`;
